import React from 'react';
import Relay from 'react-relay';
import { browserHistory } from 'react-router';

import Button from 'react-mdl/lib/Button';
import IconButton from 'react-mdl/lib/IconButton';
import Menu, { MenuItem } from 'react-mdl/lib/Menu';
import Textfield from 'react-mdl/lib/Textfield';
import { Dialog, DialogActions, DialogTitle, DialogContent } from 'react-mdl/lib/Dialog';

class MailingListRow extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isEditing: false,
            openDialog: false,
            changes: {},
        };
    }

    getListDetails() {
        return this.props.mailingList;
    }

    renderStatic() {
        let list = this.getListDetails();

        let menuBtnId = 'member-' + list.address + '-menu-btn';

        return (
            <tr onClick={() => browserHistory.push(`/mailing-lists/${list.address}`)}>
                <td className="mdl-data-table__cell--non-numeric">{list.name || <i>no name</i>} ({list.members_count})</td>
                <td className="mdl-data-table__cell--non-numeric">{list.description}</td>
                <td className="mdl-data-table__cell--non-numeric">{list.address}</td>
                <td className="mdl-data-table__cell--non-numeric">{list.access_level}</td>
                <td className="mdl-data-table__cell--non-numeric">
                    <IconButton name="more_vert" id={menuBtnId} />
                    <Menu target={menuBtnId} align="right" ripple>
                        <MenuItem onClick={() => this.setState({isEditing: true})}>Edit</MenuItem>
                        <MenuItem onClick={() => this.setState({openDialog: true})}>Delete</MenuItem>
                    </Menu>

                    <Dialog open={this.state.openDialog} onCancel={() => this.setState({openDialog: false})} style={{width: '400px'}}>
                        <DialogTitle>Delete a Member</DialogTitle>
                        <DialogContent>
                            <p>Are you sure you want to delete mailing list "{list.address}"?</p>
                        </DialogContent>
                        <DialogActions>
                            <Button type='button' onClick={() => this.setState({openDialog: false})}>Cancel</Button>
                            <Button type='button'>Delete</Button>
                        </DialogActions>
                    </Dialog>
                </td>
            </tr>
        )
    }

    renderEditing() {
        let list = this.getListDetails() || {};

        let id = (list.address || Math.random().toString());

        let change = (field, new_value) => this.setState(({changes}) => {
            changes[field] = new_value;
            return changes;
        });

        let doUpdate = () => {
            this.setState({isEditing: false, changes: {}});
        };

        return (
            <tr>
                <td className="mdl-data-table__cell--non-numeric">
                    <Textfield
                        onChange={event => change('name', event.target.value)}
                        label="Name"
                        floatingLabel
                        value={this.state.changes.name || list.name || ''}
                    />
                </td>
                <td className="mdl-data-table__cell--non-numeric">
                    <Textfield
                        onChange={event => change('description', event.target.value)}
                        label="Description"
                        floatingLabel
                        value={this.state.changes.description || list.description || ''}
                    />
                </td>
                <td className="mdl-data-table__cell--non-numeric">
                    <Textfield
                        onChange={event => change('address', event.target.value)}
                        label="Email Address"
                        floatingLabel
                        value={this.state.changes.address || list.address || ''}
                    />
                </td>
                <td className="mdl-data-table__cell--non-numeric">
                    <Button id={id + '-access-selector'} >{this.state.changes.access_level || list.access_level}</Button>
                    <Menu target={id + '-access-selector'} ripple>
                        <MenuItem onClick={() => change('access_level', 'readonly') }>Admin Only</MenuItem>
                        <MenuItem onClick={() => change('access_level', 'members')}>Members Only</MenuItem>
                        <MenuItem onClick={() => change('access_level', 'everyone')}>Everyone</MenuItem>
                    </Menu>
                </td>
                <td className="mdl-data-table__cell--non-numeric">
                    <IconButton name="save" onClick={() => doUpdate()}/>
                </td>
            </tr>
        )
    }

    render() {
        return !this.getListDetails() || this.state.isEditing ? this.renderEditing() : this.renderStatic();
    }
}

export default Relay.createContainer(MailingListRow, {
    fragments: {
        mailingList: () => Relay.QL`
            fragment on MailingList {
                access_level
                address
                description
                members_count
                name
            }
        `,
    }
});


// members {
//     name
//     address
//     vars {
//         key
//         value
//     }
// }



/** WEBPACK FOOTER **
 ** ./src/Routes/MailingLists/MailingListRow/MailingListRow.js
 **/